import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[rxApplicationsScrollToInvalid]',
})
export class ScrollToInvalidDirective {
  constructor(private el: ElementRef, private formGroupDir: FormGroupDirective) {}

  @HostListener('ngSubmit') onSubmit() {
    if (this.formGroupDir.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

  private scrollToFirstInvalidControl(): void {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector('.ng-invalid:not(form)');

    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    });
  }

  private getTopOffset(htmlElement: HTMLElement): number {
    const labelOffset = 100;
    return htmlElement.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
}
